import defaultAxios from "axios";
import toast from "react-hot-toast";

const iotAxios = defaultAxios.create({
  baseURL: process.env.REACT_APP_IOT_SERVER_URL,
  headers: {
    "X-Source": "customer-web",
  },
});

iotAxios.interceptors.response.use(
  function (response) {
    if (response?.data?.message) {
      toast.success(response.data.message);
    }
    return response;
  },
  async function (error) {
    if (error.response.status === 429) {
      toast.error("Please try again in a few minutes...");
    }
    return Promise.reject(error);
  },
);

const iotAPI = {
  recharge: (data) => iotAxios.post("/recharge", data),
};

export default iotAPI;
